[
    {
        "group": "GENERAL",
        "itemNumber": "12",
        "clauseId": "GENERAL 12",
        "standardRef": "AS/NZS 4777.1:2024 3.5.3.1",
        "question": "No more than 2 \"main switch (inverter)\" have been installed at the 1 switchboard with attached loads (AS/NZS4777.1:2024 3.5.3.1)",
        "recommendations": [
            "Reconfigure the installation so that no more than 2 “Main Switch (Inverter)” switches are installed on any one switchboard with attached loads."
        ]
    },
    {
        "group": "DC",
        "itemNumber": "3.1",
        "clauseId": "DC3.1",
        "standardRef": "AS/NZS 5033:2021 4.3.5.3.1 (f) & (g)",
        "question": "DC isolators at inverter have been mounted on a non-combustible surface or surround as outlined in AS/NZS 5033:2021 clause 4.3.5.3.1 (f), and have penetrations of DC cables with an internal free space greater than 5mm been filled with a fire-retardant material",
        "recommendations": [
            "Move the DC isolators at the inverter to a non-combustible surface or surround."
        ]
    },
    {
        "group": "DC",
        "itemNumber": "3.2",
        "clauseId": "DC3.2",
        "standardRef": "AS/NZS 5033:2021 4.4.7.3",
        "question": "Dedicated individual enclosures containing DC isolators installed at the inverter, in an outdoor environment, have been protected against the effects of weather by installation of a shroud, or under soffit installation as per AS/NZS 5033:2021 Appendix K",
        "recommendations": [
            "Install suitable weather protection for all DC isolator enclosures located at the inverter in outdoor environments. This may include fitting a compliant shroud or installing the isolators under a soffit, as detailed in AS/NZS 5033:2021 Appendix K."
        ]
    },
    {
        "group": "GENERAL",
        "itemNumber": "14",
        "clauseId": "GENERAL 14",
        "standardRef": "AS/NZS 5033:2021 2.1.6",
        "question": "Have parallel array connections been installed with matched voltages within 5% per string",
        "recommendations": [
            "Reconfigure and test the parallel-connected PV strings to confirm that their voltages are matched within 5% of each other."
        ]
    },
    {
        "group": "GENERAL",
        "itemNumber": "8",
        "clauseId": "GENERAL 8",
        "standardRef": "AS/NZS 3000 1.7.1 (c)",
        "question": "The array's minimum Vmp (at maximum temperature) is greater than 1.1 x minimum Vdc of the inverter's voltage operating window.",
        "recommendations": [
            "Install an appropriately rated inverter, such that the array’s minimum Vmp (at maximum temperature) is greater than 1.1x minimum Vdc of the inverter’s voltage operating window."
        ]
    },
    {
        "group": "GENERAL",
        "itemNumber": "9",
        "clauseId": "GENERAL 9",
        "standardRef": "AS/NZS 3000 1.7.1 (c)",
        "question": "The array's maximum voltage Varray max (at minimum temperature) is less than the maximum VDC of the inverter's voltage operation window.",
        "recommendations": [
            "Install an appropriately rated inverter, such that the array’s maximum voltage Varray max (at minimum temperature) is less than the maximum Vdc of the inverter’s voltage operating window."
        ]
    },
    {
        "group": "INSTALL",
        "itemNumber": "5",
        "clauseId": "INSTALL5",
        "standardRef": "AS/NZS 5033:2021 4.4.5.1",
        "question": "Where the PV array cable and conduit passes through a tile or steel roof, a fit for purpose collar flashing shall be installed (e.g. dektite).",
        "recommendations": [
            "The conduit penetration through the tiles has not been carried out in a compliant manner, conduits may not be passed under a tile. Please re-install using a compliant method such as a collar flashing and UV stabilized silicone."
        ]
    },
    {
        "group": "INSTALL",
        "itemNumber": "7",
        "clauseId": "INSTALL7",
        "standardRef": "AS/NZS 5033:2021 2.2.2 (a), 2.2.3 (b); AS/NZS 3000:2018 1.7.1 (c)",
        "question": "The PV Array structure allows sufficient clearance to facilitate suitable ventilation. This should also prevent any build up of leaves or debris.",
        "recommendations": [
            "Reinstall the PV Array with sufficient clearance to facilitate self-cleaning or provide a note in the maintenance procedure for periodic cleaning of debris."
        ]
    },
    {
        "group": "INSTALL",
        "itemNumber": "6",
        "clauseId": "INSTALL6",
        "standardRef": "AS/NZS 5033:2021 4.3.2.2.1, 4.4.5.1; AS/NZS 3000:2018 1.7.1 (c)",
        "question": "Tiles shall sit flat after the installation of tile mounting brackets to ensure the tiles maintain their original ingress protection. There may be a requirement to grind the underside of the tile to enable it to sit correctly.",
        "recommendations": [
            "The array structure’s roof fixings need to be installed so that they pass under the tiles without creating the potential for water penetration into the property. The array tile brackets currently cause the tiles to sit higher creating a gap which could allow water and debris to enter the roof void. Please ensure tiles sit flush to maintain the roof's previous ingress properties."
        ]
    },
    {
        "group": "GENERAL",
        "itemNumber": "10",
        "clauseId": "GENERAL 10",
        "standardRef": "AS/NZS 5033:2021 4.4.2.4",
        "question": "DC PV wiring voltage drop between the most remote PV module in the array to the input of the inverter shall not exceed 5% of the Vmp (at STC) (note: Cl 2.2.3 (c) recommends not greater than 3% voltage drop).",
        "recommendations": [
            "The PV wiring voltage drop is greater than 5%. Install appropriate DC wiring such that its losses are less than 5%.",
            "The Voltage drop is above the recommended 3%. Consider adding larger DC wiring such that losses are less than 3%."
        ]
    },
    {
        "group": "GENERAL",
        "itemNumber": "11",
        "clauseId": "GENERAL 11",
        "standardRef": "AS/NZS 4777.1:2024 3.3.3",
        "question": "Voltage rise from the point of supply to the inverter a.c. terminals shall not exceed 2% of the nominal voltage at the point of supply.",
        "recommendations": [
            "Voltage rise between the inverter terminals and point of supply is estimated at greater than the allowed 2%. Please note voltage rise calculation must be done using the stated maximum current of the IES (export limiting is not a valid input calculation as per 4777.1:2016 clause 3.3.3)"
        ]
    },
    {
        "group": "WIRING",
        "itemNumber": "20",
        "clauseId": "WIRING20",
        "standardRef": "AS/NZS 4777.1:2024 6.3 (b)",
        "question": "The connection of DC cables at the inverter are secured in a manner that prevents inadvertent disconnection.",
        "recommendations": [
            "The connection of DC cables at the inverter appear to be not adequately secured - AS/NZS5033:2021 4.4.5.2.2 Exception 2 requires DC cables to be mechanically protected and supported to prevent accidental pulling and damage - no more than 300mm of cable is exposed."
        ]
    },
    {
        "group": "COMPONENTS",
        "itemNumber": "1.1",
        "clauseId": "COMPONENTS1.1",
        "standardRef": "AS/NZS 4777.1:2024 2.4.1 (c) ; AS/NZS 5033:2021 4.5.2.1",
        "question": "Inverter is of appropriate IP rating for its location.",
        "recommendations": [
            "The installed inverter is not rated to the correct IP rating for the installation location. Move the inverter to a more sheltered location or install an inverter with an appropriate IP rating for its location."
        ]
    },
    {
        "group": "COMPONENTS",
        "itemNumber": "2.1",
        "clauseId": "COMPONENTS2.1",
        "standardRef": "AS/NZS 5033:2021 4.7.2.2 (b) (i); AS/NZS 3000:2018 3.7.2.3",
        "question": "There are no visible loose connections in low voltage cables.",
        "recommendations": [
            "Please arrange the conductors connecting the AC isolator with attention to the retention of stranded conductors at the terminals. The ends of stranded conductors shall be secured by suitable means, as to prevent the spreading or escaping of individual strands. Use of bootlaces is recommended. AS/NZS3000:2018 CL 3.7.2.5.",
            "The installed cabling was found to have loose connection with no signs of heat.",
            "Loose electrical terminations were found at the connection to the PCE",
            "Plug and socket connectors appear to be terminated without the correct tool as specified by the manufacturer.",
            "Plug and socket connector glands have not been sufficiently tightened to maintain the manufactures IP rating."
        ]
    },
    {
        "group": "CER",
        "itemNumber": "1",
        "clauseId": "CER1",
        "standardRef": "Renewable Energy Regulations 2001 20AC (5A) (d) (ii)",
        "question": "Solar PV system is capable of producing electricity at the installation address without the need for any additional parts to be incorporated.",
        "recommendations": ["Finalise the installation of the system."]
    },
    {
        "group": "CER",
        "itemNumber": "2",
        "clauseId": "CER2",
        "standardRef": "Renewable Energy Regulations 2001 20AC (10) (a) & (b)",
        "question": "Solar panels were listed on CER approved product list (as displayed on CER or accreditation body's website) at the time of the system's installation.",
        "recommendations": [
            "The PV Modules installed were not present on the CEC’s list of Approved Modules, at the time of installation."
        ]
    },
    {
        "group": "CER",
        "itemNumber": "3",
        "clauseId": "CER3",
        "standardRef": "Renewable Energy Regulations 2001 20AC",
        "question": "Inverter/s are listed on CER approved product list (as displayed on CER or accreditation body's website) at the time of the system's installation.",
        "recommendations": [
            "The Inverter/s installed were not present on the CEC’s list of Approved Inverters, at the time of installation."
        ]
    },
    {
        "group": "CER",
        "itemNumber": "4",
        "clauseId": "CER4",
        "standardRef": "Renewable Energy Regulations 2001 20AC",
        "question": "The system installed, including the model of equipment and the capacity of the system, match information provided to the REC registry",
        "recommendations": ["Installed components do not match that listed on the REC Registry."]
    },
    {
        "group": "CER",
        "itemNumber": "5",
        "clauseId": "CER5",
        "standardRef": "Product subject to recall",
        "question": "SigenStor EC 8.0/10.0/12.0kW SP AU Energy Controllers are compliant",
        "recommendations": [
            "Potentially recalled battery and/or inverter found on site. Homeowner has been notified and recommended to contact manufacturer to check if their system is on the list and ensure fixes have been applied where applicable. Ac terminal and plug area showed no signs of heat."
        ]
    },
    {
        "group": "INSTALL",
        "itemNumber": "8",
        "clauseId": "INSTALL 8",
        "standardRef": "AS/NZS4777.1:2024 3.5.3.1",
        "question": "If there is more than 1 \"main switch (inverter)\" at a switchboard with attached loads, they have been grouped together",
        "recommendations": [
            "Relocate the “main switch (inverter)\" switches so that they are grouped together."
        ]
    },
    {
        "group": "INSTALL",
        "itemNumber": "9",
        "clauseId": "INSTALL 9",
        "standardRef": "AS/NZS4777.1:2024 3.3.2",
        "question": "All AC cables installed in an outdoor environment at the inverter/s have been fixed/supported via suitable methods (AS/NZS 4777.1:2024 does not allow the use of plastic cable ties for this purpose)",
        "recommendations": [
            "Replace or secure the outdoor AC cables using suitable fixings such as stainless-steel cable ties, metal saddles, or other UV-stable, weather-resistant supports."
        ]
    },
    {
        "group": "GENERAL",
        "itemNumber": "4.2.1",
        "clauseId": "GENERAL 4.2.1",
        "standardRef": "AS/NZS4777.1:2024 4.3.2",
        "question": "The maximum voltage of the array on a domestic dwelling does not exceed 1000 VDC",
        "recommendations": [
            "Reconfigure the system so that the array maximum voltage does not exceed 1000V DC."
        ]
    },
    {
        "group": "DC",
        "itemNumber": "1.1.1.1.1.1.1",
        "clauseId": "DC1.1.1.1.1.1.1",
        "standardRef": "AS/NZS3000:2018 4.1.2 &4.1.3; AS/NZS 5033:2021 4.5.3.1",
        "question": "The d.c. isolator enclosure/s at the inverter have the required IP rating (minimum IP 56NW if outdoors) and have been correctly installed to prevent water ingress (there may be a requirement for a greater IP rating depending on location, refer to AS/NZS 3000:2018 Appendix G).",
        "recommendations": [
            "Install a DC Isolator enclosure that has an appropriate IP rating.",
            "Reinstall the DC Isolator enclosure to the manufacturer’s instructions to maintain its IP rating.",
            "At present the cables exiting the conduit attached to the enclosure is a single gland where a multi hole gland needs to be installed.",
            "At present conduit enters the top of the DC isolator enclosure. Relocate the cable entries to the bottom of the enclosure.",
            "Seal mounting screws as per the manufacturer’s instructions.",
            "Seal cable entries as per the manufacturer’s instructions."
        ]
    },
    {
        "group": "DC",
        "itemNumber": "1.1.2.1.1.1",
        "clauseId": "DC1.1.2.1.1.1",
        "standardRef": "AS/NZS3000:2018 4.1.2 &4.1.3; AS/NZS 5033:2021 4.5.3.1",
        "question": "The d.c. isolator enclosure/s at the inverter have no signs of water damage.",
        "recommendations": [
            "A DC isolator has been found with signs of water entry at the inverter. Please ensure all enclosures containing DC disconnection devices are installed in line with AS/NZS 5033:2021 Clause 4.4.6 & 4.4.7"
        ]
    },
    {
        "group": "DC",
        "itemNumber": "1.2.1.1.1.1.1",
        "clauseId": "DC1.2.1.1.1.1.1",
        "standardRef": "AS/NZS3000:2018 4.1.2 &4.1.3; AS/NZS 5033:2021 4.5.3.1",
        "question": "The d.c. isolator located adjacent to the inverter is correctly rated for actual required DC voltage and current in accordance with AS/NZS 5033.",
        "recommendations": [
            "The DC isolator at the inverter is not rated for the connected DC voltage and current. Please ensure ratings are calculated based on the lowest recorded temperature for the installation site."
        ]
    },
    {
        "group": "DC",
        "itemNumber": "1.3.1.1.1.1",
        "clauseId": "DC1.3.1.1.1.1",
        "standardRef": "AS/NZS 5033:2021 4.3.4.2",
        "question": "The load break disconnector at the inverter, connected to the array is DC rated.",
        "recommendations": ["The load break disconnector at the inverter is not rated for DC use."]
    },
    {
        "group": "DC",
        "itemNumber": "1.4.1",
        "clauseId": "DC1.4.1",
        "standardRef": "AS/NZS 5033:2021 4.5.4.1",
        "question": "The load break disconnector is mounted adjacent to inverter input and the inverter is not in sight or more than three metres from the array. \"adjacent\" is defined in AS/NZS 3000 1.4.6.",
        "recommendations": [
            "A load break disconnector for the inverter has not been installed within arm’s reach of the inverter."
        ]
    },
    {
        "group": "DC",
        "itemNumber": "1.5.1.1.1",
        "clauseId": "DC1.5.1.1.1",
        "standardRef": "AS/NZS 5033:2021 4.3.4.2.2 (e)",
        "question": "The load break disconnector is securable in the off position.",
        "recommendations": [
            "The load break disconnector is not securable in the off position. If the isolator/load break disconnection device does not comply an adjacent compliant device shall be installed."
        ]
    },
    {
        "group": "DC",
        "itemNumber": "1.6.1",
        "clauseId": "DC1.6.1",
        "standardRef": "AS/NZS 3000:2018 2.1.2 (f)",
        "question": "The load break disconnector at the inverter is correctly wired.",
        "recommendations": [
            "Please arrange the conductors at the inverter isolator with attention to the retention of stranded conductors at the terminals. The ends of stranded conductors shall be secured by suitable means, to prevent the spreading or escaping of individual strands. Use of bootlaces is recommended. AS/NZS 3000:2018 Clause 3.7.2.5.",
            "The DC isolator in its current wiring configuration is underrated for voltage and/or current. Rewire the DC Isolator so that it maintains the required per pole voltage rating."
        ]
    },
    {
        "group": "DC",
        "itemNumber": "1.7",
        "clauseId": "DC1.7",
        "standardRef": "AS/NZS 5033:2021 4.3.4.2.2 (d) and (g)",
        "question": "The load break disconnector at the inverter interrupt all live conductors simultaneously and is not polarity sensitive.",
        "recommendations": [
            "Install a non-polarised DC isolator at the inverter.",
            "Ensure that the DC isolator at the inverter activates in all active conductors."
        ]
    },
    {
        "group": "DC",
        "itemNumber": "1.8.1",
        "clauseId": "DC1.8.1",
        "standardRef": "AS/NZS 5033:2021 4.5.4.1 (b)",
        "question": "The load break disconnector at the inverter is readily available.",
        "recommendations": [
            "Correctly install the DC isolator at the inverter so that it is readily available.",
            "At present the integrated isolator is above two meters."
        ]
    },
    {
        "group": "DC",
        "itemNumber": "1.9.1",
        "clauseId": "DC1.9.1",
        "standardRef": "AS/NZS 5033:2021 4.5.4.2",
        "question": "If multiple load break disconnectors are installed at the inverter, they are grouped so that they operate simultaneously or grouped in a common location with a warning sign indicating the need to isolate multiple supplies to isolate the equipment.",
        "recommendations": [
            "Correctly install the DC isolators so that they are grouped in a common location."
        ]
    },
    {
        "group": "DC",
        "itemNumber": "2.1.1.1.1.1",
        "clauseId": "DC2.1.1.1.1.1",
        "standardRef": "AS/NZS 5033:2021 4.4.6.1",
        "question": "The d.c. isolator enclosure/s at the array have a minimum IP55 rating, have been correctly installed to prevent water ingress and have no signs of water damage.",
        "recommendations": [
            "The array DC isolator components have signs of damage due to water ingress and need to be replaced. Therefore, the inspector has temporarily rendered the system safe by [INSERT_ACTION_TAKEN]",
            "The isolator installed at the array is not installed to maintain IP.",
            "Cable glands, conduits and fittings shall not enter/exit the top face of enclosures unless they are between adjacent and physically separate load break disconnectors and/or a PCE and all are located indoors.",
            "Cable glands used to enter an enclosure containing d.c. conductor terminations in an outdoor environment must be installed so that each cable enters/exits through an individual hole.",
            "Multi-hole glands used to enter an enclosure containing d.c. conductor terminations in an outdoor environment must have any spare holes sealed with the gland manufacturers approved sealing plugs.",
            "All cable glands that enter/exit the side face of an enclosure containing d.c. conductor terminations and installed in an outdoor environment, must have all glands located within a protected zone of 30 degree as outlined in figure 4.8 and 4.9 of AS/NZS 5033:2021"
        ]
    },
    {
        "group": "DC",
        "itemNumber": "2.2.1",
        "clauseId": "DC2.2.1",
        "standardRef": "AS/NZS 5033:2021 4.3.4.1",
        "question": "The load break disconnector located immediately adjacent to the array is correctly rated for actual required DC voltage and current.",
        "recommendations": [
            "The DC isolator at the array is not rated for the connected DC voltage and current. Please ensure ratings are calculated based on the lowest recorded temperature for the installation site."
        ]
    },
    {
        "group": "DC",
        "itemNumber": "2.3.1",
        "clauseId": "DC2.3.1",
        "standardRef": "AS/NZS 3000:2018.1.2 (f)",
        "question": "The load break disconnector adjacent to the array is correctly wired.",
        "recommendations": [
            "Please arrange the conductors at the array isolator with attention to the retention of stranded conductors at the terminals. The ends of stranded conductors shall be secured by suitable means, so as to prevent the spreading or escaping of individual strands. Use of bootlaces is recommended. AS/NZS 3000:2018 Clause 3.7.2.5.",
            "The DC isolator in its current wiring configuration is underrated for voltage and/or current. Rewire the DC Isolator so that it maintains the required per pole voltage rating."
        ]
    },
    {
        "group": "DC",
        "itemNumber": "2.4.1",
        "clauseId": "DC2.4.1",
        "standardRef": "AS/NZS 5033:2021 4.3.3.2.1",
        "question": "A disconnection points or load break disconnector is located adjacent to the array. \"adjacent\" is defined in AS/NZS 3000:2018 1.4.6.",
        "recommendations": [
            "A disconnection point or load break disconnector has not been installed within arm’s reach of the array it controls."
        ]
    },
    {
        "group": "DC",
        "itemNumber": "2.5.1",
        "clauseId": "DC2.5.1",
        "standardRef": "AS/NZS 5033:2021 4.3.5.2.1 (b) 4.3.5.3.1 (b)",
        "question": "A disconnection points or load break disconnector at the array are readily available. \"available, readily\" is defined in AS/NZS 3000:2018 1.4.19.",
        "recommendations": [
            "Isolators installed under an array do not have adequate access for inspection, maintenance or repairs."
        ]
    },
    {
        "group": "DC",
        "itemNumber": "2.7",
        "clauseId": "DC2.7",
        "standardRef": "AS/NZS 5033:2021 4.3.3.1",
        "question": "If the calculated PV d.c circuit maximum voltage exceeds 120 V, a load break disconnector is installed at the array if required by the AS/NZS 5033:2021 Figure 4.2 decision tree",
        "recommendations": [
            "As per figure 4.2 decision tree an isolator is required to be installed at the array but has not been."
        ]
    },
    {
        "group": "DC",
        "itemNumber": "2.8",
        "clauseId": "DC2.8",
        "standardRef": "AS/NZS 5033:2021 4.3.3.1",
        "question": "Where a load break disconnector is not required at the array by the AS/NZS 5033:2021 Figure 4.2 decision tree, a “disconnection point” has been provided per AS/NZS 5033:2021 clause 4.3.5.2.1",
        "recommendations": [
            "A disconnection point has not been provided for safe isolation of the solar system at the array."
        ]
    },
    {
        "group": "DC",
        "itemNumber": "2.9",
        "clauseId": "DC2.9",
        "standardRef": "AS/NZS 5033:2021 4.3.5.2.1",
        "question": "Disconnection point/s at the array are installed correctly.",
        "recommendations": [
            "Disconnection points at the array are not located adjacent to the strings they control.",
            "Disconnection points at the array are not protected against weather and water as required.",
            "Disconnection points at the array are located further than 150mm from the edge of the panel.",
            "Disconnection points at the array are loose. They must be adequately supported.",
            "Disconnection points at the array must be adequately supported but still be able to be disconnected. Reinstall the cable supports so that the DPs can be disconnected.",
            "Disconnection points at the array must have both the positive and negative disconnection devices located together.",
            "The pest mesh installed around the perimeter of the array restricts access to the disconnection points. As the inspector cannot confirm when this was installed this is a general comment only."
        ]
    },
    {
        "group": "DOC",
        "itemNumber": "1.1",
        "clauseId": "DOC1.1",
        "standardRef": "AS/NZS 5033:2021 6.2 (d)",
        "question": "The owner of the system has been provided a copy of the shutdown and isolation procedure for emergency and maintenance.",
        "recommendations": [
            "Please ensure that all required documentation is supplied to customer in accordance with AS/NZS 5033:2021 clause 6.2 (d). A Shutdown and Isolation Procedure was not sighted in the documentation provided to the customer."
        ]
    },
    {
        "group": "DOC",
        "itemNumber": "10.1",
        "clauseId": "DOC10.1",
        "standardRef": "AS/NZS 5033:2021 6.2 (e)",
        "question": "The owner of the system has been provided a basic system connection diagram that includes the electrical ratings of the PV array, and ratings of all overcurrent devices and switches as installed.",
        "recommendations": [
            "Please ensure that all required documentation is supplied to customer in accordance with AS/NZS 5033:2021 clause 6.2(e). Basic system connection diagram was not sighted in the documentation provided to the customer."
        ]
    },
    {
        "group": "DOC",
        "itemNumber": "11.1",
        "clauseId": "DOC11.1",
        "standardRef": "AS/NZS 5033:2021 6.2 (i)",
        "question": "The owner of the system has been provided a commissioning sheet/s and installation checklist.",
        "recommendations": [
            "Please ensure that all required documentation is supplied to customer in accordance with AS/NZS 5033:2021 clause 6.2(i). Testing and commissioning was not sighted in the documentation provided to the customer."
        ]
    },
    {
        "group": "DOC",
        "itemNumber": "12.1",
        "clauseId": "DOC12.1",
        "standardRef": "AS/NZS 5033:2021 6.2 (c)",
        "question": "The owner of the system has been provided a list of actions to be taken in the event of an earth fault alarm.",
        "recommendations": [
            "Please ensure that all required documentation is supplied to customer in accordance with AS/NZS 5033:2021 clause 6.2 (c). List of actions to be taken in the event of an earth fault alarm was not sighted in the documentation provided to the customer."
        ]
    },
    {
        "group": "DOC",
        "itemNumber": "13.1",
        "clauseId": "DOC13.1",
        "standardRef": "AS/NZS 5033:2021 6.2 (h)",
        "question": "The owner has been provided a recommended maintenance procedure and timetable with safety warnings.",
        "recommendations": [
            "Please ensure that all required documentation is supplied to customer in accordance with AS/NZS 5033:2021 Clause 6.2 (h). Maintenance procedure and timetable was not sighted in the documentation provided to the customer."
        ]
    },
    {
        "group": "DOC",
        "itemNumber": "14.1",
        "clauseId": "DOC14.1",
        "standardRef": "AS/NZS 5033:2021 6.2 (k)",
        "question": "The owner has been provided warranty Information [equipment and installation].",
        "recommendations": [
            "Please ensure that all required documentation is supplied to customer in accordance with AS/NZS 5033:2021 Clause 6.2(k). Warranty information (equipment and installation) was not sighted in the documentation provided to the customer."
        ]
    },
    {
        "group": "DOC",
        "itemNumber": "2.1",
        "clauseId": "DOC2.1",
        "standardRef": "AS/NZS 5033:2021 6.2 (l)",
        "question": "The owner of the system has been provided manufacturer's documentation [data sheets, handbooks, etc].",
        "recommendations": [
            "Please ensure that all required documentation is supplied to customer in accordance with AS/NZS 5033:2021 Clause 6.2(l). manufacturer's documentation [data sheets, handbooks, etc] was not sighted in the documentation provided to the customer."
        ]
    },
    {
        "group": "DOC",
        "itemNumber": "3.1",
        "clauseId": "DOC3.1",
        "standardRef": "AS/NZS 5033:2021 6.2 (j)",
        "question": "The owner of the system has been provided a copy of the engineering certificate stating that the array frame is certified to AS1170.2 for the location.",
        "recommendations": [
            "Please ensure that all required documentation is supplied to customer in accordance with AS/NZS 5033:2021 Clause 6.2(j). An engineering certificate stating that the array frame is certified to AS1170.2:2021 for the location was not sighted in the documentation provided to the customer."
        ]
    },
    {
        "group": "DOC",
        "itemNumber": "7.1",
        "clauseId": "DOC7.1",
        "standardRef": "AS/NZS 5033:2021 6.2 (a)",
        "question": "The owner of the system has been provided a short description of the function and operation of installed equipment.",
        "recommendations": [
            "Please ensure that all required documentation is supplied to customer in accordance with AS/NZS 5033:2021 Clause 6.2(a). A short description of the function and operation of installed equipment was not sighted in the documentation provided to the customer."
        ]
    },
    {
        "group": "DOC",
        "itemNumber": "8.1",
        "clauseId": "DOC8.1",
        "standardRef": "AS/NZS 5033:2021 6.2 (g)",
        "question": "The owner of the system has been provided a system performance [energy output] estimate.",
        "recommendations": [
            "Please ensure that all required documentation is supplied to customer in accordance with AS/NZS 5033:2021 Clause 6.2(g). Site specific performance estimate was not sighted in the documentation provided to the customer."
        ]
    },
    {
        "group": "DOC",
        "itemNumber": "9.1",
        "clauseId": "DOC9.1",
        "standardRef": "AS/NZS 5033:2021 6.2 (b)",
        "question": "The owner of the system has been provided a list of equipment supplied.",
        "recommendations": [
            "Please ensure that all required documentation is supplied to customer in accordance with AS/NZS 5033:2021 Clause 6.2(b). A list of equipment supplied was not sighted in the documentation provided to the customer."
        ]
    },
    {
        "group": "PROTECTION",
        "itemNumber": "5.2",
        "clauseId": "PROTECTION5.2",
        "standardRef": "AS/NZS 3000:2018 1.7.1(b)(c)",
        "question": "All array earthing lugs have been installed ensuring they do not make contact with solar panel cell backing sheets",
        "recommendations": [
            "Reposition or adjust all array earthing lugs to ensure there is no contact with the solar panel cell backing sheets. Verify that all earthing terminations are secure and maintain electrical continuity."
        ]
    },
    {
        "group": "PROTECTION",
        "itemNumber": "5.3",
        "clauseId": "PROTECTION5.3",
        "standardRef": "AS/NZS 3000:2018 1.7.1(b)(c)",
        "question": "All array earthing lugs have been installed ensuring they do not make contact with solar panel cell backing sheets",
        "recommendations": [
            "Panel earth lug has been installed making direct contact with the underside of panel causing damage to the protective film on underside of panel. Assess damage for the need for replacement."
        ]
    },
    {
        "group": "GENERAL",
        "itemNumber": "1.1",
        "clauseId": "GENERAL 1.1",
        "standardRef": "AS/NZS 4777.1:2024 3.4.3.2",
        "question": "If the inverter is not adjacent (within arm's reach) to the switchboard connected to the inverter, an AC isolator is provided at the inverter. \"Adjacent\" is defined as \"within arm’s reach\" in AS/NZS 3000 1.4.6.",
        "recommendations": [
            "The AC isolator for micro inverters has been installed under the array and cannot be accessed for inspection.",
            "An AC isolator has not been provided within arm’s reach of the installed inverter."
        ]
    },
    {
        "group": "GENERAL",
        "itemNumber": "2.2",
        "clauseId": "GENERAL 2.2",
        "standardRef": "AS/NZS 3000:2018 1.7.2 (d); AS/NZS 3000:2018 1.7.1 (c)",
        "question": "Inverter [or any heavy part of system] is installed/mounted safely and there appears no imminent risk of the item falling.",
        "recommendations": ["Reinstall the inverter so that it is securely fixed to the wall."]
    },
    {
        "group": "GENERAL",
        "itemNumber": "2.1.1.1",
        "clauseId": "GENERAL 2.1.1.1",
        "standardRef": "AS/NZS4777.1:2024 2.4.1; AS/NZS 3000:2018 1.7.2 (c)",
        "question": "Inverter has been installed in a location that has sufficient space and access and adequate working space.",
        "recommendations": ["Inverter has not been installed as per manufacturers guidelines."]
    },
    {
        "group": "GENERAL",
        "itemNumber": "3",
        "clauseId": "GENERAL 3",
        "standardRef": "AS/NZS 5033:2021 2.1.6",
        "question": "Modules in the same string are installed in the same orientation within +/- 5 degrees.",
        "recommendations": [
            "PV modules that are electrically in the same series string shall be within ± 5 degrees azimuth and ± 5 degrees tilt angle."
        ]
    },
    {
        "group": "GENERAL",
        "itemNumber": "5.1",
        "clauseId": "GENERAL5.1",
        "standardRef": "AS/NZS 4777.1 2016 2.3",
        "question": "There is adequate clearance around the inverter in accordance with inverters manufactures recommendation with adequate space and ventilation.",
        "recommendations": [
            "The inverter’s installation manual specifies a clearance of REQUIREMENT mm to each side of the inverter. Only MEASUREMENT mm has been provided.",
            "The inverter’s installation manual specifies a clearance of REQUIREMENT mm from all sides of the inverter. Only MEASUREMENT mm has been provided.",
            "The inverter’s installation manual specifies a clearance of REQUIREMENT mm above the inverter. Only MEASUREMENT mm has been provided.",
            "The inverter’s installation manual specifies a clearance of REQUIREMENT mm below the inverter. Only MEASUREMENT mm has been provided."
        ]
    },
    {
        "group": "GENERAL",
        "itemNumber": "6.1",
        "clauseId": "GENERAL 6.1",
        "standardRef": "AS/NZS 4777.2:2020",
        "question": "Inverter is configured to AS/NZS 4777.2:2020 Region A,B or C.",
        "recommendations": [
            "NV for all settings",
            "The installed inverter has not been set to the correct region as per AS/NZS 4777.2:2020 requirements e.g. Australia A, Australia B, Australia"
        ]
    },
    {
        "group": "GENERAL",
        "itemNumber": "6.2",
        "clauseId": "GENERAL 6.2",
        "standardRef": "AS/NZS 4777.2:2020, Local DNSP connection requirements",
        "question": "Inverter is configured to local Distribution Network Service Provider requirements for grid protection in Region A, B or C (e.g. maximum 10-minute avg. voltage, Vnom-max).",
        "recommendations": [
            "NV for all settings",
            "The installed inverter has not been set to the correct region as per AS/NZS 4777.2:2020 requirements e.g. Australia A, Australia B, Australia C"
        ]
    },
    {
        "group": "GENERAL",
        "itemNumber": "6.3",
        "clauseId": "GENERAL 6.3",
        "standardRef": "AS/NZS 4777.2:2020, Local DNSP connection requirements",
        "question": "Inverter is configured to local Distribution Network Service Provider requirements for power quality response modes in Region A, B or C (e.g. Volt_Watt, Volt_var).",
        "recommendations": [
            "NV for all settings",
            "The installed inverter has not been set to the correct region as per AS/NZS 4777.2:2020 requirements e.g. Australia A, Australia B, Australia C"
        ]
    },
    {
        "group": "GENERAL",
        "itemNumber": "7",
        "clauseId": "GENERAL7",
        "standardRef": "AS/NZS 5033:2021 Cl 4.3.2.3.2",
        "question": "Where PV modules are within 2.5m from the ground, floor or platform and are not installed on a roof, restricted access is provided to PV modules and wiring systems up to the disconnection point.",
        "recommendations": ["Provide restricted access to the array with appropriate signage."]
    },
    {
        "group": "INSTALL",
        "itemNumber": "1.1",
        "clauseId": "INSTALL1.1",
        "standardRef": "AS/NZS 4777.1:2024 3.4.3.1",
        "question": "AC circuit breaker on switchboard is securable in the open position.",
        "recommendations": [
            "Please ensure AC circuit breaker on switchboard is securable in the open position."
        ]
    },
    {
        "group": "INSTALL",
        "itemNumber": "2.1.1",
        "clauseId": "INSTALL2.1.1",
        "standardRef": "AS/NZS 4777.1:2024 3.4.1",
        "question": "An AC circuit breaker is mounted within the switchboard to act as main switch for the PV / inverter system and to protect the cable from the switchboard to the inverter.",
        "recommendations": [
            "Install an AC circuit breaker within the switchboard to act as the main switch for the PV/inverter system."
        ]
    },
    {
        "group": "INSTALL",
        "itemNumber": "3.1.1",
        "clauseId": "INSTALL3.1.1",
        "standardRef": "AS/NZS 4777.1:2024 3.4.2",
        "question": "The AC circuit breaker is correctly rated to protect the AC cable installed between the inverter and switchboard to which it is connected.",
        "recommendations": [
            "The CB Installed is not correctly rated to provide adequate circuit protection to the installed cables.",
            "The installed AC circuit breaker is rated higher than the current carrying capacity of the AC cable connected between the inverter and switchboard."
        ]
    },
    {
        "group": "INSTALL",
        "itemNumber": "4.1.1",
        "clauseId": "INSTALL4.1.1",
        "standardRef": "AS/NZS 4777.1:2024 3.3.1 & 3.4.1",
        "question": "The AC cables installed between the inverter and the switchboard to which it is connected are rated at a minimum of the inverter’s maximum output current.",
        "recommendations": [
            "The current carrying capacity of the ac cable between the switchboard and inverter is rated less than the maximum output current of the inverter."
        ]
    },
    {
        "group": "MECH",
        "itemNumber": "1.1",
        "clauseId": "MECH1.1",
        "standardRef": "AS/NZS 5033:2021 4.3.2.2.5",
        "question": "PV mounting structure and attachment to roof visually inspected and appears to be secure.",
        "recommendations": [
            "Ensure there is a gap between module rows to allow for thermal expansion. At present no gap between rows has been provided and therefore this may not be consistent with manufactures installation guidelines.",
            "Modules are installed outside of the required clamping zone specified by the module manufacture. At present modules have an overhang of up to MEASUREMENT mm.",
            "The PV Array has been installed in close proximity to the gutters, AS1170.2:2021 requires the PV Array to be a min of 2S away from the roof edges. please seek clarification from frame and panel manufacturers on compliant installation zones.",
            "Please ensure end clamps have been installed correctly, please confirm that installation method complies with manufacturers guidelines.",
            "At times existing roof screws have been used to secure the tin feet brackets to the roof. Original roofing screws are not suitable to be reused in a PV mounting system.",
            "Feet Spacings must not exceed manufacturer’s instructions. Please confirm manufacturers installation instructions for the installed environment.",
            "Ensure all mid clamps are installed as per manufactures installation guidelines. The mid clamps should be installed hard up against each module frame.",
            "Panels are installed overhanging the roof ridges. Reinstall the panels so that they do not overhang or install additional fixings to allow for this overhang. Alternatively, provide documentation that confirms that the current configuration is within manufacturer’s installation guidelines.",
            "Panels are installed overhanging the roof valleys. Reinstall the panels so that they do not overhang or install additional fixings to allow for this overhang. Alternatively, provide documentation that confirms that the current configuration is within manufacturer’s installation guidelines."
        ]
    },
    {
        "group": "MECH",
        "itemNumber": "2.1",
        "clauseId": "MECH2.1",
        "standardRef": "AS/NZS 5033:2021 4.3.2.2.5",
        "question": "Any freestanding PV structure was visually inspected and appears to be secure.",
        "recommendations": [
            "Ensure there is a gap between module rows to allow for thermal expansion. At present no gap between rows has been provided and therefore this may not be consistent with manufactures installation guidelines.",
            "Modules are installed outside of the required clamping zone specified by the module manufacture. At present modules have an overhang of up to MEASUREMENT mm.",
            "Please ensure end clamps have been installed correctly, please confirm that installation method complies with manufacturers guidelines.",
            "Ensure all mid clamps are installed as per manufactures installation guidelines. The mid clamps should be installed hard up against each module frame."
        ]
    },
    {
        "group": "MECH",
        "itemNumber": "3",
        "clauseId": "MECH3",
        "standardRef": "AS/NZS 5033:2021 4.3.2.2.8",
        "question": "All array supports, brackets, screws and other metal parts are either: (a) of similar material or stainless steel to minimise corrosion; or (b) where dissimilar metals that can have a galvanic reaction are used, that they are galvanically isolated.",
        "recommendations": [
            "Saddles have been installed directly to the roof surface to secure conduit. Ensure rubber is installed and replace saddles and screws with stainless steel products to ensure dissimilar metals do not touch.",
            "The saddles installed to secure roof mounted Solar conduit have signs of corrosion. Replace saddles and screws with stainless steel products."
        ]
    },
    {
        "group": "PROTECTION",
        "itemNumber": "1.1",
        "clauseId": "PROTECTION1.1",
        "standardRef": "AS/NZS 5033:2021 4.3.7",
        "question": "Where there are several PV array strings and could result in a potential fault current in any one string greater than reverse current of an individual module - appropriate string protection is provided. [e.g. Fuses or non-polarised circuit breakers].",
        "recommendations": ["String Protection has not been provided where required at the array."]
    },
    {
        "group": "PROTECTION",
        "itemNumber": "2.1.1",
        "clauseId": "PROTECTION2.1.1",
        "standardRef": "AS/NZS 5033:2021 4.3.6",
        "question": "If string protection is installed, its specification allows its use for DC application and appropriate current.",
        "recommendations": [
            "The installed string overcurrent protection is not rated for its intended use."
        ]
    },
    {
        "group": "PROTECTION",
        "itemNumber": "4.1",
        "clauseId": "PROTECTION4.1",
        "standardRef": "AS/NZS 5033:2021 Cl 4.6.7",
        "question": "If a transformer-less inverter [non-galvanically isolated] is installed, a functional earth is not connected to the DC positive or negative.",
        "recommendations": ["Remove the functional earth connected to the DC positive or negative."]
    },
    {
        "group": "PROTECTION",
        "itemNumber": "5",
        "clauseId": "PROTECTION5",
        "standardRef": "AS/NZS 5033:2021 4.6.4",
        "question": "The PV array mounting frames and modules have an equipotential bond connected to the earthing terminal on the switchboard/distribution board to which the inverter is connected, either directly or via the inverter main earth conductor.",
        "recommendations": [
            "The PV Array equipotential bonding/earthing has not been carried out in a compliant manner, in accordance with AS/NZS 3000:2018 and AS/NZS 5033:2021 Clause 4.6.5. The PV Array or part therefore was found to not be provided with an adequate earth bond as required.",
            "At time of inspection no piercing washer were installed between the module frames and the array rail.",
            "The inverter frame has not been earthed as specified by the manufacturer. As the site includes a multimode inverter, a battery and an alternative supply, this issue is significant and requires rectification. This is due to the potential risk of electric shock at the inverter, albeit rare and highly specific."
        ]
    },
    {
        "group": "PROTECTION",
        "itemNumber": "5.1",
        "clauseId": "PROTECTION5.1",
        "standardRef": "AS/NZS 5033:2021 4.6.3",
        "question": "The PV array frame and/ module earthing connections and methods comply with standards requirements",
        "recommendations": [
            "Ensure there is no mechanical stress on the earthing conductors terminated at the earth bonding lugs at the array. AS/NZS 3000:2018 clause 3.7.2.6 Mechanical stress - All cables and conductors shall be installed so that there is no undue mechanical stress on any connection.",
            "Flexible stranded earthing conductors have been used at the earth grounding lugs at the array. These have been incorrectly terminated as outlined in AS/NZS 5033 clause 4.4.2.2(a). Some of these fittings are not designed for stranded cable so not all are suitable without the use of a small copper plate to retain cable stands.",
            "Piercing earthing lug washers need to be installed following manufacturers specifications. The piercing dimple needs to be installed in-between the earthing lug and rail.",
            "Ensure piercing washers at module clamps are fitted correctly adhering to manufacturer’s specifications. The piercing dimple should be installed between the module frame and rail.",
            "Ensure that earth cable connection at array is protected against the effects of corrosion, earth lugs have not been painted."
        ]
    },
    {
        "group": "PROTECTION",
        "itemNumber": "6",
        "clauseId": "PROTECTION6",
        "standardRef": "AS/NZS 5033:2021 4.3.6.4 (a)",
        "question": "If string protection is installed, the fuse holders have a current rating equal to or greater than the corresponding fuse",
        "recommendations": ["Install appropriately rated fuse holders."]
    },
    {
        "group": "PROTECTION",
        "itemNumber": "7.1",
        "clauseId": "PROTECTION7.1",
        "standardRef": "AS/NZS 5033:2021 4.6.7",
        "question": "If the PV array has direct functional earthing, an Earth Fault Interrupter is installed.",
        "recommendations": [
            "As the system has direct functional earthing (i.e. it is not earthed via a resistor) an Earth Fault Interrupter is required. Install an Earth Fault Interrupter."
        ]
    },
    {
        "group": "PROTECTION",
        "itemNumber": "8",
        "clauseId": "PROTECTION8",
        "standardRef": "AS/NZS 5033:2021 4.6.5",
        "question": "The cross-sectional area of the earthing conductors for the PV array are of the correct size to comply with Standards",
        "recommendations": [
            "At present the 4mm earth from the array is terminated at the inverter and then relies on the earth conductor 2.5mm cable within the multicore cable for connection to the switchboard. Ensure that all earthing cable is a minimum of 4mm."
        ]
    },
    {
        "group": "SIGN",
        "itemNumber": "1.1",
        "clauseId": "SIGN1.1",
        "standardRef": "AS/NZS 5033:2021 5.3.2",
        "question": "PV cable junction boxes are labelled 'WARNING: HAZARDOUS DC VOLTAGE'",
        "recommendations": [
            "A warning label containing the warning symbol and 'WARNING: HAZARDOUS DC VOLTAGE', is not attached to junction boxes housing the terminations of PV d.c. cable."
        ]
    },
    {
        "group": "SIGN",
        "itemNumber": "10",
        "clauseId": "SIGN10",
        "standardRef": "AS/NZS 5033:2021 5.5.2.1",
        "question": "If multiple d.c. isolators are installed at the inverter the correct warning sign indicating the need to operate all DC isolators to isolate the equipment is present.",
        "recommendations": [
            "Multiple d.c. isolators are installed at the inverter and the correct warning sign indicating the need to operate all DC isolators to isolate the equipment is not present."
        ]
    },
    {
        "group": "SIGN",
        "itemNumber": "11",
        "clauseId": "SIGN11",
        "standardRef": "AS/NZS5033:2021 5.6",
        "question": "Solar system layout is shown on a plan (map or drawing) suitably affixed and protected at the main switchboard and/or meter box. The sign information sign is in English and correctly labelled. The sign shows installation address, building plan with location of PCE and PV array(s), correct map legend, location of the site information sign with the words \"you are here\", components on the drawing that are indicative of the actual installation, and installation date.",
        "recommendations": [
            "A site plan has not been provided at the main switchboard/meter board as required.",
            "The solar system layout at main switchboard is not labelled \"PV (solar) site information\" in white letters with a red background.",
            "The solar system layout at main switchboard is not labelled with the location address as recorded for the installation.",
            "Please add the postcode and state to the address line.",
            "The solar system layout at main switchboard does not contain a plan view of the building showing the location of the PCE and/or PV array/s.",
            "The solar system layout at main switchboard does not identify the location of site plan with the word “you are here”.",
            "The installation date has not been marked on the system layout plan.",
            "The layout provided is not suitably affixed and protected. Re-install the sign so that it is sufficiently durable for the location.",
            "A compliant site plan has been provided however some of the detail is hard to read."
        ]
    },
    {
        "group": "SIGN",
        "itemNumber": "12",
        "clauseId": "SIGN12",
        "standardRef": "AS/NZS 5033:2021 clause 5.6.1.1 (a)",
        "question": "Where the installed PV System is DC, the site information at the Main Switch Board and/or Meter Box includes the path of the d.c. cabling, location of d.c.disconnection point(s) indicated by \"DP\", location of additional load break disconnector(s), PV arrary size, d.c. Voltage and warning on d.c. disconnection type(s) can only be operated by suitable qualified personnel.",
        "recommendations": [
            "As no site plan was installed there was also no additional information supplied as per AS/NZS 5033:2021 clause 5.6.1.1 (a).",
            "The path of d.c. cabling has not been provided in the onsite plan",
            "The location of d.c. disconnection point/s indicated by \"\"DP\"\" has not been provided in the onsite plan.",
            "The location of additional load break disconnector/s has not been provided in the onsite plan.",
            "The PV array size has not been provided in the onsite plan.",
            "d.c. Voltage has not been provided in the onsite plan.",
            "The onsite plan does not contain a warning where d.c. disconnection type/s can only be operated by suitable qualified personnel."
        ]
    },
    {
        "group": "SIGN",
        "itemNumber": "2.1",
        "clauseId": "SIGN2.1",
        "standardRef": "AS/NZS 5033:2021 5.7",
        "question": "Shutdown procedure is correct and is permanently fixed at inverter and/or on main switchboard. For PV array disconnectors, the shutdown procedure shall include \"WARNING: PV ARRAY D.C. ISOLATORS DO NOT DE-ENERGIZE THE PV ARRAY AND PV CABLES.",
        "recommendations": [
            "Some items listed on the shutdown procedure do not align with the labels on electrical isolation equipment located onsite.",
            "The wording of the procedure does not match the labelling of the PV Array DC Isolator.",
            "A yellow label with black wording stating “WARNING PV array D.C. isolators do not de-energize the PV array and array cabling” must be included with the shutdown procedure."
        ]
    },
    {
        "group": "SIGN",
        "itemNumber": "13",
        "clauseId": "SIGN13",
        "standardRef": "AS/NZS5033:2021 5.3.1.2, 4.4.5.2.3 after Fig 4.6",
        "question": "The sign \" WARNING: HAZARDOUS d.c. VOLTAGE Solar d.c. cables in conduit have been installed in this ceiling space. The conduit is labelled 'SOLAR' and care must be taken while working nearby. The internal solar d.c. cables may be live and must not be disturbed or damaged. \" is present within accessible ceiling or floor space.",
        "recommendations": [
            "Install the correct warning sign within accessible ceiling space.",
            "The warning sign installed is missing the \"WARNING: HAZARDOUS d.c VOLTAGE\" LABEL"
        ]
    },
    {
        "group": "SIGN",
        "itemNumber": "3.1",
        "clauseId": "SIGN3.1",
        "standardRef": "AS/NZS 4777.1:2024 6.4",
        "question": "If the solar system is connected to a distribution board, the following sign is located on the main switchboard and all intermediate distribution boards \"WARNING MULTIPLE SUPPLIES ISOLATE INVERTER SUPPLY AT DISTRIBUTION SWITCHBOARD AT (LOCATION)\". Intermediate distribution switchboard is defined in AS/NZS 4777.1:2016 1.3.14.",
        "recommendations": [
            "An inverter has been connected at a distribution board however the required “Warning Multiple Supplies Isolate Inverter Supply at Distribution Switchboard at …” Has not been placed at the main switchboard.",
            "The label is present, but the wording does not comply with standards requirements. Replace the current label with ‘WARNING MULTIPLE SUPPLIES ISOLATE INVERTER SUPPLY AT DISTRIBUTION SWITCHBOARD AT (LOCATION)’."
        ]
    },
    {
        "group": "SIGN",
        "itemNumber": "14",
        "clauseId": "SIGN14",
        "standardRef": "AS/NZS 5033:2021 5.5.2.2",
        "question": "Where a “Disconnection Point” has been provided, the sign \"WARNING: LOADS MUST BE ISOLATED AND CIRCUIT MUST BE TESTED FOR THE ABSENCE OF CURRENT BEFORE UNPLUGGING\" is attached to both the positive and negative cable within 100 mm of the disconnection point of the PV string. The minimum text size is 10 mm.",
        "recommendations": [
            "The required signs have not been installed.",
            "Signs have not been installed within 100mm of the disconnection points.",
            "A sign has not been placed on both the positive and negative cables at the disconnection point of the array."
        ]
    },
    {
        "group": "SIGN",
        "itemNumber": "4.1",
        "clauseId": "SIGN4.1",
        "standardRef": "AS/NZS 4777.1:2024 6.3 (a)",
        "question": "The AC Circuit breaker in the switchboard is labelled: \"MAIN SWITCH (INVERTER SUPPLY)\".",
        "recommendations": [
            "Permanently fix a label ‘Main Switch (Inverter)’ to the AC circuit breaker.",
            "The label is present, but the wording does not comply with standards requirements at time of installation. Replace the current label with ‘MAIN SWITCH (INVERTER)’. A MAIN SWITCH (INVERTER) shall be provided on the switchboard to which the IES is directly connected. AS/NZS 4777.1:2024 6.3 (a)"
        ]
    },
    {
        "group": "SIGN",
        "itemNumber": "5.1",
        "clauseId": "SIGN5.1",
        "standardRef": "AS/NZS 4777.1:2024 6.3 (g)",
        "question": "Sign – ‘WARNING MULTIPLE SUPPLIES ISOLATE ALL SUPPLIES BEFORE WORKING ON THIS SWITCHBOARD’ is located on the switchboard.",
        "recommendations": [
            "A sign needs to be installed on the sub board.",
            "A sign needs to be installed on the main switchboard.",
            "The gateway beside the inverter contains multiple protection devices and as such is classified as a switchboard as per AS/NZS 3000:2018 clause 1.4.121 definition. As the switchboard contains multiple supplies it is required to be labelled as per the requirements outlined in section 6 of AS/NZS 4777.1:2024",
            "A label is present, but the wording does not comply with standards requirements at time of the installation. Replace the current label with a yellow sign with black text ‘‘WARNING MULTIPLE SUPPLIES ISOLATE ALL SUPPLIES BEFORE WORKING ON THIS SWITCHBOARD’ and locate it on the switchboard as per AS/NZS 4777.1:2024 6.3 (g)"
        ]
    },
    {
        "group": "SIGN",
        "itemNumber": "15",
        "clauseId": "SIGN15",
        "standardRef": "AS/NZS5033:2021 5.5.2.2",
        "question": "Where a “Disconnection Point” has been provided, the sign “WARNING: PV STRING DISCONNECTION POINT\" is attached to the PV module or structure within 300mm of the disconnection point to identify the location of the disconnection point. The minimum text size is 10 mm.",
        "recommendations": [
            "A sign stating “WARNING: PV STRING DISCONNECTION POINT\" has not been placed on the pv module or structure within 300mm of the disconnection device.",
            "Relocated the warning sign within 300mm of the disconnection point."
        ]
    },
    {
        "group": "SIGN",
        "itemNumber": "7.2.1",
        "clauseId": "SIGN7.2.1",
        "standardRef": "AS/NZS 5033:2021 5.4",
        "question": "A 100 mm diameter circular green reflector PV sign with the letters AC , DP, or SW indicating the isolation method is installed on or adjacent to the meter box and switchboard and is readily available to be seen by approaching emergency workers",
        "recommendations": [
            "The Circular green reflector sign of at least 100mm in diameter, with the letters \"PV\", is not installed on metre box and switchboard and visible on approach.",
            "A green PV sign has been installed but it is not the correct size. Install a circular green reflector at least 100mm in diameter with the letters 'PV' to the main switchboard.",
            "The circular green \"PV\" reflector has partially peeled off. As per AS/NZS 5033:2021 5.4: all labels and signs shall be sufficiently durable for purpose.",
            "A “Disconnection Point” type system has been installed but “DP” is not displayed under green PV label at meter box and/or main switchboard.",
            "A “load break disconnection point” type system has been installed but “SW” is not displayed under green PV label at meter box and/or main switchboard.",
            "An AC type system has been installed but “AC” is not displayed under green PV label at meter box and/or main switchboard."
        ]
    },
    {
        "group": "SIGN",
        "itemNumber": "8.1.1",
        "clauseId": "SIGN8.1.1",
        "standardRef": "AS/NZS 5033:2021 5.5.1, AS/NZS3000.:2018 Cl 2.3.4.4",
        "question": "d.c. isolator/s near inverter and the array are appropriately marked.",
        "recommendations": [
            "Please ensure that integrated DC isolator at the inverter is labelled in accordance with AS/NZS 5033:2021 clauses 5.5.1.",
            "Install a new sign labelled ‘PV Array D.C. Isolator’ on the DC isolator at the inverter as required.",
            "Where there is more than one isolator, the isolators shall be individually labelled e.g. ‘PV Array DC isolator inverter 1 MPPT A’."
        ]
    },
    {
        "group": "SIGN",
        "itemNumber": "9.1.1.1",
        "clauseId": "SIGN9.1.1.1",
        "standardRef": "AS/NZS 4777.1:2024 6.3 (b)",
        "question": "Grid supply main switch is labelled ‘MAIN SWITCH (GRID SUPPLY)’ or similar, which is required when the inverter is directly connected to the main switchboard.",
        "recommendations": [
            "Permanently fix a label ‘MAIN SWITCH (GRID SUPPLY)’ or similar to the grid supply main switch.",
            "Where the inverter is connected to a distribution switchboard, a sign containing the text ‘MAIN ISOLATOR (NORMAL SUPPLY)’ is required. This sign shall be installed adjacent to the isolator(s) for the normal supply to the distribution switchboard."
        ]
    },
    {
        "group": "PROTECTION",
        "itemNumber": "3.1",
        "clauseId": "PROTECTION3.1",
        "standardRef": "AS/NZS 5033:2021 3.6",
        "question": "If lightning protection has been installed, it has been installed in accordance with AS/NZS 5033:2021 3.6.",
        "recommendations": [
            "The array has been wired in a way that creates a conductive loop. Re-install the array cables (including earthing) so that they run parallel to each other. (See AS/NZS 5033 4.4.4.4)"
        ]
    },
    {
        "group": "WIRING",
        "itemNumber": "23",
        "clauseId": "WIRING23",
        "standardRef": "AS/NZS 5033:2021 4.4.5.2.3 & 4.4.5.2.4",
        "question": "Wiring systems between disconnection point and inverter, or Non adjacent same string pv modules, when installed in a ceiling space and within 1m to 1.5m from a external wall have been fixed/attached to the roof structure",
        "recommendations": [
            "Secure conduit to the roof structure where it is 1m to 1.5m from an external wall."
        ]
    },
    {
        "group": "WIRING",
        "itemNumber": "24",
        "clauseId": "WIRING24",
        "standardRef": "AS/NZS 3000:2018 4.1.3",
        "question": "All AC isolators and enclosures installed in an outdoor environment have the correct IP rating and have been installed to uphold that IP rating, with no evidence of water ingress.",
        "recommendations": [
            "Seal the mounting screw at the back of the AC isolator.",
            "The installed gland where cables exit the enclosure and conduit is only suitable for a single cable, reinstall using a gland that is designed for multiple cables.",
            "Seal the cable entry into AC isolator enclosure, including holes at the back.",
            "Pips covering enclosure screws on lid are missing."
        ]
    },
    {
        "group": "WIRING",
        "itemNumber": "10.2",
        "clauseId": "WIRING10.2",
        "standardRef": "AS/NZS 5033:2021 4.4.6; AS/NZS3000:2018 4.1.3",
        "question": "PV cable junction boxes exposed to the outdoor environment have an IP 55 rating and have been correctly installed to prevent water ingress and have no signs of water damage (may require higher IP rating dependant on tropical locations).",
        "recommendations": [
            "A junction box has been installed exposed to the weather and feeding into a conduit system that contains conductor terminations and is not adequately IP rated for the installation area."
        ]
    },
    {
        "group": "WIRING",
        "itemNumber": "10.1.1",
        "clauseId": "WIRING10.1.1",
        "standardRef": "AS/NZS 5033:2021 4.4.6; AS/NZS3000:2018 4.1.3",
        "question": "PV cable junction boxes exposed to the outdoor environment have an IP 55 rating and have been correctly installed to prevent water ingress (may require higher IP rating dependant on tropical locations).",
        "recommendations": [
            "A junction box has been installed exposed to the weather and feeding into a conduit system that contains conductor terminations and is not adequately IP rated for the installation area."
        ]
    },
    {
        "group": "WIRING",
        "itemNumber": "11.1",
        "clauseId": "WIRING11.1",
        "standardRef": "AS/NZS 5033:2021 4.4.3.2",
        "question": "Segregation must be maintained between PV d.c. circuits and other non-PV d.c. cables. Effective segregation can be achieved by separation of 50 mm or greater, or by segregating one cable by a medium duty insulating wiring enclosure.",
        "recommendations": [
            "AC and DC cabling have not been segregated at the inverter. Provide fixed separation of 50 mm or greater, or by segregating one cable by a medium duty insulating wiring enclosure, such as conduit.",
            "AC and DC cabling have not been segregated at the switchboard. Provide fixed separation of 50 mm or greater, or by segregating one cable by a medium duty insulating wiring enclosure, such as conduit.",
            "AC and DC cabling have not been segregated within cable tray. Provide fixed separation of 50 mm or greater, or by segregating one cable by a medium duty insulating wiring enclosure, such as conduit."
        ]
    },
    {
        "group": "WIRING",
        "itemNumber": "12.1",
        "clauseId": "WIRING12.1",
        "standardRef": "AS/NZS3000:2018 2.10.7",
        "question": "The installation shall be such that it minimises the spread of any fire which might result within the system. Any new circuit breaker holder, junction box or similar must not allow any fire to escape the enclosure onto any combustible material.",
        "recommendations": [
            "The main switchboard contains penetration through a surface that protects against the spread of fire with internal diameter greater 5mm and has not been sealed with a fire-retardant material.",
            "Please ensure switchboard is sealed against the spread of fire in accordance with the requirements of AS/NZS 3000:2018 Clause 3.9.9 & 1.5.12, where any penetration has been made and where cables exit the enclosure. This includes existing holes within the switchboard when a new circuit is added."
        ]
    },
    {
        "group": "WIRING",
        "itemNumber": "13.1",
        "clauseId": "WIRING13.1",
        "standardRef": "AS/NZS 5033:2021 5.3.1.1",
        "question": "Where PV array cabling is not installed directly behind and adjacent to the PV modules, it is distinctively marked ‘SOLAR’ on the exterior surface of the cabling at intervals not exceeding 2 meters and is visible after mounting.",
        "recommendations": [
            "Where conduit or other wiring enclosure is used, the wiring enclosure shall be visibly labelled ‘SOLAR DC’ on the exterior surface at an interval not exceeding 2m. If fixed to a surface, the identification shall be visible after mounting."
        ]
    },
    {
        "group": "WIRING",
        "itemNumber": "16.1.1",
        "clauseId": "WIRING16.1.1",
        "standardRef": "AS/NZS 3000:2018 3.9.4; AS/NZS 5033: Cl 4.4.5.2.2 through to Cl 4.4.5.2.4",
        "question": "Array wiring and wiring to the inverter is protected from mechanical damage. This requires a visual inspection of all cables related to the system and therefore might require checking on the roof.",
        "recommendations": [
            "Where PV d.c. cables are installed external to the building, and not in a restricted access location, they shall be installed in a wiring enclosure to ensure restricted access of the PV d.c cables.",
            "The Earth cable does not penetrate the roof via the conduit and therefore is not protected. Please reinstall through the conduit that passes through the dek-tite. Ensure the cable is also mechanically protected through the roof penetration. AS/NZS 3000:2018 Cl. 3.10.3.5 (b) also requires the following: Where a wiring system consisting of sheathed cables is installed through metallic structural members, any aperture through which the cable passes through shall be bushed or shaped to minimize abrasion of the cable."
        ]
    },
    {
        "group": "WIRING",
        "itemNumber": "16.2.1.1",
        "clauseId": "WIRING16.2.1.1",
        "standardRef": "AS/NZS 5033:2021 4.4.2.1 (f)",
        "question": "d.c. array wiring and d.c. wiring to the inverter is protected from UV. This requires a visual inspection of all cables related to the system and therefore might require checking on the roof.",
        "recommendations": [
            "Fix the exposed section of DC cable into position so that it is not exposed to UV. Alternatively confirm that the cable is UV resistant."
        ]
    },
    {
        "group": "WIRING",
        "itemNumber": "17",
        "clauseId": "WIRING17",
        "standardRef": "AS/NZS 5033:2021 4.4.3.3, AS/NZS 5033:2021 4.4.6.2",
        "question": "Double insulation has been maintained between any live conductor and any earthed or exposed conductive part.",
        "recommendations": [
            "Insulated, unsheathed cables shall be enclosed in a wiring enclosure throughout their entire length. Ac cable between meter box and Enphase weatherproof enclosure running through cavity appear to be single insulated. AS/NZS 3000:2018 3.10.1.1",
            "Cover the mounting screws with additional silicone within the DC rooftop isolator to maintain double insulation between earthed and live parts."
        ]
    },
    {
        "group": "WIRING",
        "itemNumber": "18",
        "clauseId": "WIRING18",
        "standardRef": "AS/NZS 5033:2021 4.4.5.2.2",
        "question": "All DC cable installed within the ceiling space, wall cavity or floor is enclosed in heavy duty [HD] conduit.",
        "recommendations": [
            "The solar DC cables within building cavities are not in heavy duty conduit.",
            "Install heavy duty conduit for solar DC wiring within the roof space.",
            "Install heavy duty conduit for solar DC wiring within the wall cavity.",
            "Please ensure all solar dc cabling installed in ceilings, wall cavities and under floors are enclosed in HD conduit.",
            "Although enclosed in HD conduit, the joints have come apart in the roof cavity exposing the DC Conductors. All conduits containing solar d.c. cabling are to be securely joined using methods such as glue AS/NZS 5033:2021 clause 4.5.5.1",
            "DC cables installed in roof space have been enclosed in “Medium Duty” conduit."
        ]
    },
    {
        "group": "WIRING",
        "itemNumber": "19",
        "clauseId": "WIRING19",
        "standardRef": "AS/NZS 5033:2021 4.3.9.1 (d)",
        "question": "All DC connectors are only mated with those from the same manufacturer and designed to be mated together at a connection point.",
        "recommendations": [
            "Interconnectors at the end of the arrays are of different type/model or are from different manufacturers. Reinstall interconnectors of the same type/model from the same manufacturer for each pairing of connectors. Please ensure that all DC connectors are mated with those of the same type from the same manufacturer in accordance with AS/NZS 5033:2021 Clause 3.3.9.1 (d)."
        ]
    },
    {
        "group": "WIRING",
        "itemNumber": "21",
        "clauseId": "WIRING21",
        "standardRef": "AS/NZS 5033:2021 4.4.5.2.3",
        "question": "Where a “Disconnection Point” has been provided, the conduit containing DC cabling where installed within the ceiling space, has not been installed within 600mm of the ceiling except within permitted zones. Refer to AS/NZS 5033:2021 Figure 4.5 and 4.6 for examples.",
        "recommendations": [
            "A disconnection point has been installed and wiring between the disconnection point and the inverter has been installed more than 1.5m from an external wall and less than 0.6m from the ceiling. Relocate and secure conduit so that is not within 600mm of the ceiling except in permitted zones."
        ]
    },
    {
        "group": "WIRING",
        "itemNumber": "22",
        "clauseId": "WIRING22",
        "standardRef": "AS/NZS 5033:2021 4.4.7.2.3",
        "question": "Where any continuous conduit system that has any section of it outdoors and terminates into a disconnection device, a “drain device” is fitted at the lowest point of the conduit.",
        "recommendations": [
            "A continuous conduit system that has a section exposed to the outdoor environment and terminates into an enclosure containing d.c. conductor terminations and has not been provided with an adequately rated liquid draining device at the lowest point of the conduit system."
        ]
    },
    {
        "group": "WIRING",
        "itemNumber": "2.1.1",
        "clauseId": "WIRING2.1.1",
        "standardRef": "AS/NZS 5033:2021 4.4.3.1",
        "question": "All cables/wiring in the installation are securely fixed in place to minimise any movement of the cable.",
        "recommendations": [
            "Please ensure all cables at the array are secured in place in accordance with the requirements of AS/NZS AS/NZS 3000:2018 clause 3.9.3 & 3.3.2.8 & AS/NZS 5033:2021 Clause 4.4.3.1. Array cables under the array are loose and touching the roof surface. Secure the module cables to the array frame with clips or another accepted method.",
            "Plastic cable ties are used as a primary means of support, support cables with an accepted method.",
            "Use an appropriate method to secure the conduit running across the roof.",
            "Use saddles to secure the conduit running down the wall.",
            "The conduits installed between rows of modules are secured in the valley of the corrugated roof preventing normal water flow."
        ]
    },
    {
        "group": "WIRING",
        "itemNumber": "4.1",
        "clauseId": "WIRING4.1",
        "standardRef": "AS/NZS 3000:2018 1.5.14, 3.3.2.10",
        "question": "Array wiring and wiring is protected from fauna where deemed necessary.",
        "recommendations": [
            "Cabling shows initial signs of being damaged by fauna. Conceal wiring in conduit so it is protected from fauna.",
            "Cabling shows initial signs of being damaged by fauna. Clip up or reduce the length of cabling to minimise risk of damage from fauna."
        ]
    },
    {
        "group": "WIRING",
        "itemNumber": "5.1.1",
        "clauseId": "WIRING5.1.1",
        "standardRef": "AS/NZS 5033:2021 4.4.2.1 ,4.4.2.2",
        "question": "Array wiring and wiring to inverter is rated for the voltage and current.",
        "recommendations": [
            "The installed cabling is not adequately rated for the connected Voltage and current."
        ]
    },
    {
        "group": "WIRING",
        "itemNumber": "6.2",
        "clauseId": "WIRING6.2",
        "standardRef": "AS/NZS 3000:2018 3.7.3",
        "question": "All joints in cables are enclosed e.g. in junction boxes and/or comply with the exceptions of AS/NZS 3000 Clause 3.7.3.",
        "recommendations": ["Enclose cabling joints in junction boxes."]
    },
    {
        "group": "WIRING",
        "itemNumber": "7.1",
        "clauseId": "WIRING7.1",
        "standardRef": "AS/NZS 3000:2018 8.2",
        "question": "There is no evidence of mechanical damage to LV cables.",
        "recommendations": [
            "Cables have not been sufficiently protected against abrasion, tension, compression and cutting forces that may arise from thermal cycles, wind and other forces.",
            "The Array wiring has been found to not be protected from mechanical damage as required.",
            "Wiring at the roof penetration has evidence of mechanical damage. Either install new wiring in conduit and ensure it is not being crushed or install new wiring with a dektite (or equivalent)."
        ]
    },
    {
        "group": "WIRING",
        "itemNumber": "8.1",
        "clauseId": "WIRING8.1",
        "standardRef": "AS/NZS 5033:2021 4.4.2.1",
        "question": "d.c. array wiring and d.c. wiring to the inverter is single conductor cable both insulated and sheathed",
        "recommendations": [
            "Replace cabling with SDI at [INSERT_LOCATION]",
            "Ensure double insulation is maintained. [PROVIDE_DETAILS]"
        ]
    },
    {
        "group": "WIRING",
        "itemNumber": "8.2",
        "clauseId": "WIRING8.2",
        "standardRef": "AS/NZS 5033:2021 4.4.2.1",
        "question": "PV d.c. cables are temperature rated appropriate for the application, UV-resistant or protected from UV light if exposed to the environment, and flexible in accordance with IEC 60228 if directly terminated to plugs/socket/connectors.",
        "recommendations": [
            "At the [INSERT_LOCATION] install cabling that is temperature rated for the location.",
            "At the [INSERT_LOCATION] install flexible (multi-stranded) cabling."
        ]
    },
    {
        "group": "WIRING",
        "itemNumber": "9.1",
        "clauseId": "WIRING9.1",
        "standardRef": "AS/NZS 3000:2018 3.9.4",
        "question": "LV array and inverter cables are installed with adequate protection near building surfaces as per AS/NZS 3000 requirements",
        "recommendations": [
            "DC cables have been installed within 50mm of a building surface and are not adequately mechanically protected.",
            "AC cables have been installed within 50mm of a building surface and are not adequately mechanically protected."
        ]
    },
    {
        "group": "WIRING",
        "itemNumber": "1.1",
        "clauseId": "WIRING1.1",
        "standardRef": "AS/NZS 3000:2018 1.5.3.1",
        "question": "There are no exposed live parts on any installed equipment.",
        "recommendations": [
            "Accessible live parts were observed on site. Re-install cabling to AS/NZS 3000."
        ]
    },
    {
        "group": "WIRING",
        "itemNumber": "15.1",
        "clauseId": "WIRING15.1",
        "standardRef": "AS/NZS 3000:2018 1.6 & 1.7",
        "question": "All electrical equipment for the system is installed in accordance with AS/NZS 3000.",
        "recommendations": [
            "Please identify corresponding neutral. Main Switch (Inverter Supply) shall be marked or arranged to identify corresponding Active and Neutral connections for each circuit. AS/NZS 3000:2018 Cl. 2.10.5.4",
            "The circuits that exit the switchboard run through an unprotected hole at the back of the switchboard. Where a wiring system consisting of sheathed cables is installed through metallic structural members, any aperture through which the cable passes through which the cable passes shall be bushed or shaped to minimize abrasion of the cable. AS/NZS 3000:2018 Cl. 3.10.3.5",
            "Comms cables are required to be separated as per AS/NZS 3000:2018 Clause 3.9.8.4 C, a minimum of 50 mm. The comms cable must meet the clauses in AS/NZS 3000 for the prevention of mutual detrimental effects between services.",
            "Install pole fillers so that fingers cannot access live parts without the use of a tool. AS/NZS3000:2018 2.5.5.2 NOTES2 The required degree of protection, IP2X or IP1XB, is to prevent the entry of objects and contact with live parts by a person’s finger.",
            "Enclosures with more than 1 circuit and associated protective devices are classed as a distribution board as per AS/NZS 3000:2018 definitions, and thus are required to be labelled as per the requirements of AS/NZS 4777.1:2024 and required to have a neutral bar and separate neutral terminals for each outgoing circuit as per AS/NZS 3000:2018 clause 2.10.4.3 requirements"
        ]
    }
]
